module.exports = __webpack_public_path__ + "img/edit.dfed9c19.svg";